import { formatPrice } from '@/shared/lib/utils/price/format-price'

import cl from './style.module.scss'

export interface DolyamePayTableProps {
	items: { PRICE: number; DATE: string }[]
}

export const DolyamePayTable = (props: DolyamePayTableProps) => {
	const { items } = props

	return (
		<div className={cl.root}>
			<div className={cl.items}>
				{items.map(item => (
					<div className={cl.item} key={item.DATE}>
						<p className={cl.title}>{item.DATE}</p>
						<p className={cl.price}>{formatPrice(item.PRICE)}</p>
						<div className={cl.line} />
					</div>
				))}
			</div>
			<p className={cl.note}>Примерный график, может быть сервисный сбор</p>
		</div>
	)
}
